<template>
	<div>
		<list-renderer :apiUrl="'/api/users/listall'" :filterIn="filterIn" :listInData="'allUsers'">
			<template #header="{title}">
				<h2>Users</h2>
				<div class="ml-auto" v-if="userRoles.includes('users.create')">
					<a class="btn btn-md btn-success" @click="openModal()"><i class="fas fa-plus"></i> New User</a>
				</div>
			</template>
			<template #content='{list,rawData}'>

				<div class="table-responsive">
					<table>
						<thead>
						<tr>
							<th>Name</th>
							<th>Email</th>
							<th>Last Updated</th>
							<th v-if="userRoles.includes('users.delete')">Actions</th>
						</tr>
						</thead>
						<tbody>
						<tr v-for="user in list">
							<td>
								<a :href="'/users/' + user.id +'/edit'" class="article-title"><strong>{{
										user.name
									}}</strong></a>
								<div class="article-links">
									<a v-if="userRoles.includes('users.update')" :href="'/users/' + user.id +'/edit'">Edit</a>
								</div>
							</td>

							<td>{{ user.email }}</td>
							<td>{{ user.lastUpdated }}</td>
							<td v-if="userRoles.includes('users.delete')">
								<a @click="banUser(user.id)" href="#" title="Ban" class="btn btn-icon btn-warning"><i class="fas fa-ban"></i></a>
								<a @click="deleteUser(user.id)" href="#" title="Delete" class="btn btn-icon btn-danger"><i class="fas fa-trash-alt"></i></a>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</template>
		</list-renderer>


		<modal @close="closeModal" v-show="isModalVisible">
			<template slot="header">
				<h4 class="modal-title">Create New User</h4>
			</template>
			<template slot="body">
				<div class="flex box start">
					<div class="form-group six">
						<label for="firstname">First Name</label>
						<input id="firstname" class="input-large" type="text" required v-model="newUserData.first_name">
						<p class="input-error" v-if="errors.errors['first_name']">{{ errors.errors['first_name'] }}</p>
					</div>
					<div class="form-group six">
						<label for="lastname">Last Name</label>
						<input id="lastname" class="input-large" type="text" required v-model="newUserData.last_name">
						<p class="input-error" v-if="errors.errors['last_name']">{{ errors.errors['last_name'] }}</p>
					</div>
				</div>
				<div class="form-group">
					<label for="email">Email Address</label>
					<input id="email" type="email" value="" required v-model="newUserData.email">
					<p class="input-error" v-if="errors.errors['email']">{{ errors.errors['email'] }}</p>
				</div>
			</template>
			<template slot="footer">
				<a @click="closeModal" aria-label="Close modal" class="btn btn-md btn-primary modal-close" href="#"><i
						class="fas fa-times"></i> Cancel</a>
				<a @click="createUser" class="btn btn-md btn-success" href="#"><i class="fas fa-save"></i> Save Changes</a>
			</template>
		</modal>

	</div>
</template>

<script>
import modal from "../Modal/DefaultModal.vue";
import Errors from '../../Utils/Errors.js';

export default {
	components: {
		modal
	},
	props: {},
	data() {
		return {
			userList: this.dataUserList,
			endPoint: this.dataEndpoint,
			urlParams: this.dataUrlParams || [],
			isModalVisible: false,
			newUserData: {
				first_name: null,
				last_name: null,
				email: null
			},
			errors: new Errors(),
			userRoles: this.$currentUserRoles,

			selectedSite: this.$selectedSite,
			filterIn: ['name', 'email'],
		}
	},
	methods: {
		openModal: function () {
			this.isModalVisible = true;
		},
		closeModal: function () {
			this.isModalVisible = false;
		},
		createUser: function () {
			let vm = this;

			axios.post('/api/users', vm.newUserData)
					.then(response => {
						if (response.data.success) {
							this.$toastr.success('New user saved.');
							vm.closeModal();
							setTimeout(function () {
								window.location.reload();
							}, 1000);
						} else {
							vm.errors.record(e.response.data);
							this.$toastr.error('Save new user failed.', 'Error');
						}
					})
					.catch(e => {
						vm.errors.record(e.response.data);
						this.$toastr.error('Save new user failed.', 'Error');
					});
		},
		banUser: function (id) {
			let vm = this;
			vm.$dialog.confirm('Are you sure you want to ban this user?')
					.then(function (dialog) {
						axios.post('/api/users/' + id + '/ban')
								.then(function (response) {
									vm.$toastr.success('User deleted.');
									window.location.reload();
								})
								.catch(function (e) {
									vm.$toastr.error('User ban failed.', 'Error');
								})
					})
					.catch(function (error) {
						vm.$toastr.error('Ban aborted.');
					});
		},
		deleteUser: function (id) {
			let vm = this;
			vm.$dialog.confirm('Are you sure you want to delete this user?')
					.then(function (dialog) {
						axios.delete('/api/users/' + id)
								.then(function (response) {
									vm.$toastr.success('User deleted.');
									window.location.reload();
								})
								.catch(function (e) {
									vm.$toastr.error('User delete failed.', 'Error');
								})
					})
					.catch(function (error) {
						vm.$toastr.error('Delete aborted.');
					});
		}
	}
}
</script>

<style scoped>

</style>
